/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2012 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { userTypes } from '../../login/login.config';
import { licenseobject } from './license';

export class subscriptionobject extends licenseobject {
  subscription_id: number = 0;
  subscription_key: string = "";
  owner: string = "";
  inception_date: any = NaN;
  date_renewed: any = NaN;
  agreed_to_terms: boolean = false;
  currency_code: string = "";

  constructor() {
    super();
  }

  gettablename(): string {
    return "SUBSCRIPTION";
  }
}
